<script setup>
import Header from "@/modules/public/components/Header";
</script>

<template>
  <section
    class=""
    style="height: 100vh; background-position: center; background-size: cover"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/Ventus/ventus-man.jpeg') + ')',
    }"
  >
    <Header />
    <div
      class="d-flex flex-col justify-content-center align-items-center h-100"
    >
      <div class="container px-sm-2 px-md-7 mt-10">
        <div class="col-xs-12 col-md-7">
          <h5 class="text-white">Cotizador Ventus</h5>
          <h1 class="text-white">
            ¡Obtén una cotización<br />
            personalizada en minutos!
          </h1>
          <p class="text-light text-lg">
            Hemos simplificado el proceso de cotización para que obtengas<br />
            la propuesta económica que necesitas en cuestión de minutos.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
